export { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const EMPTY_LABEL = '—';
export const ENRICHMENT_DATA_TEST_UPGRADE_SOURCE = 'enrichment-data-test';
export const MODAL_MIN_BLOCK_SIZE = '14rem';
export const MODAL_WIDTH = '34rem';